import { isCommentResolved, isCommentUnresolved } from "lib/comments";
import { createSelector } from "reselect";

import { getSaleStatus } from "lib/sale";
import {
  getActiveRole,
  getSales,
  getSaleSubTypes,
  getSaleyards,
  getSpecies,
  getSaleStatuses,
} from "../root";
import { selectCommentsByDeploymentSaleIdLookup } from "../comments";
import { selectEffectiveSaleTitleBySaleIdLookup } from "../sales";

export interface LivestockSaleAgGridRowType {
  livestockSale: {
    id: number;
    sale_type: string;
    saleSubType: SaleSubType;
    date: string;
    sale_title: string;
    species: Species;
    deploymentSaleId: number | null;
    saleCode: string;
    saleyard: SaleYardType;
    status: string;
  };
  resolvedCommentCount: number;
  unResolvedCommentCount: number;
}

export const selectSalesAggridData = createSelector(
  [
    getSales,
    getSpecies,
    getSaleSubTypes,
    selectCommentsByDeploymentSaleIdLookup,
    getSaleyards,
    getActiveRole,
    getSaleStatuses,
    selectEffectiveSaleTitleBySaleIdLookup,
  ],
  (
    sales,
    species,
    saleSubTypes,
    commentsByDeploymentSaleId,
    saleYards,
    activeRole,
    saleStatuses,
    effectiveSaleTitleBySaleIdLookup,
  ) =>
    Object.values(sales).map((sale: Sale): LivestockSaleAgGridRowType => {
      const saleSubType = saleSubTypes[sale.sale_sub_type_id];

      // Comments are on a deployment sale, and only agency driven.   Only populate if there's just one!
      const deploymentSaleId =
        sale.deployment_sales.length === 1
          ? sale.deployment_sales[0].deployment_sale_id
          : null;
      const resolvedCommentCount = deploymentSaleId
        ? commentsByDeploymentSaleId[deploymentSaleId].filter(isCommentResolved)
            .length
        : 0;
      const unResolvedCommentCount = deploymentSaleId
        ? commentsByDeploymentSaleId[deploymentSaleId].filter(
            isCommentUnresolved,
          ).length
        : 0;

      // If we have a deployment sale status, use that.
      const deploymentSaleStatus = sale.deployment_sales[0]?.deploymentStatusId;
      let status = null;
      if (deploymentSaleStatus) {
        status = saleStatuses[deploymentSaleStatus]?.name;
      }

      if (!status) {
        status = getSaleStatus(sale, activeRole);
      }

      return {
        livestockSale: {
          id: sale.id,
          sale_type: sale.sale_type,
          saleSubType,
          date: sale.date,
          sale_title:
            effectiveSaleTitleBySaleIdLookup[sale.livestocksale_id] ?? "",
          species: species[sale.species_id],
          deploymentSaleId,
          saleCode: sale.sale_code,
          saleyard: saleYards[sale.saleyard_id],
          status,
        },
        resolvedCommentCount,
        unResolvedCommentCount,
      };
    }),
);
